<style>

  .container {
    font-family: Helvetica, Arial, Roboto, sans-serif !important; 
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    display: flex;
    min-height: 90vh;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .row {
    max-width: 25rem;
  }
  h1 {
    font-size: 2rem;
    color: #d15c87;
    font-weight: 600;
    line-height: 1.25;
    margin: 0.67em auto;
  }
  p {
    font-size: 1.2rem;
    color: #777;
    line-height: 1.25;
    margin: 0.52em auto;
    
  }
</style>

<svelte:head>
	<title>Page Not Found • Cue Admin</title>
</svelte:head>

<div class="container">
  <div class="row">
    <h1>We can't find the page you're looking for.</h1>
    <p>The page may have been moved or removed.</p>
  </div>
</div>
